import { useState, useEffect, useCallback } from 'react';

import './styles.scss';

export const UnauthorizedModal = () => {
  const [visible, setVisible] = useState(false);

  const handleUnauthorized = useCallback(() => {
    setVisible(true);
  }, []);

  useEffect(() => {
    window.addEventListener('api:gateway-unauthorized', handleUnauthorized);
    return () => {
      window.removeEventListener('api:gateway-unauthorized', handleUnauthorized);
    };
  }, [handleUnauthorized]);

  if (!visible) return null;

  return (
    <div className="unauthorized-modal__overlay" onClick={() => setVisible(false)}>
      <div className="unauthorized-modal" onClick={(e) => e.stopPropagation()}>
        <div className="unauthorized-modal__icon" aria-hidden="true">🔒</div>
        <h3 className="unauthorized-modal__title">Access Denied</h3>
        <p className="unauthorized-modal__message">
          You do not have the required permissions to perform this action.
          Please contact your administrator if you believe this is an error.
        </p>
        <button
          type="button"
          className="unauthorized-modal__btn"
          onClick={() => setVisible(false)}
        >
          Close
        </button>
      </div>
    </div>
  );
};

export default UnauthorizedModal;
